import { Skeleton } from '@gravity-ui/uikit';

import styles from './styles.module.scss';

const n = 14;

export const BlankTableLoader = ({ isAdaptive }: any) => {
	return (
		<>
			{isAdaptive ? (
				<div className={styles.blank_table_loader}>
					<div className={styles.blank_table_loader__block}>
						<div className={styles.blank_table_loader__block__start}>
							<Skeleton style={{ maxWidth: '17px', height: '17px' }} />

							<Skeleton style={{ maxWidth: '167px', height: '42px' }} />
							<Skeleton style={{ maxWidth: '44px', height: '44px' }} />
							<Skeleton style={{ maxWidth: '44px', height: '44px' }} />
							<Skeleton style={{ maxWidth: '44px', height: '44px' }} />
							<Skeleton style={{ maxWidth: '44px', height: '44px' }} />
						</div>
						<div className={styles.blank_table_loader__block__end}>
							<Skeleton style={{ maxWidth: '696px', height: '42px' }} />
							<Skeleton style={{ maxWidth: '696px', height: '42px' }} />
							<Skeleton style={{ maxWidth: '696px', height: '42px' }} />
						</div>
					</div>
					<div className={styles.blank_table_loader__block}>
						<div className={styles.blank_table_loader__block__start}>
							<Skeleton style={{ maxWidth: '17px', height: '17px' }} />
							<div>
								<Skeleton style={{ maxWidth: '167px', height: '42px' }} />
								<Skeleton style={{ maxWidth: '44px', height: '44px' }} />
								<Skeleton style={{ maxWidth: '44px', height: '44px' }} />
								<Skeleton style={{ maxWidth: '44px', height: '44px' }} />
								<Skeleton style={{ maxWidth: '44px', height: '44px' }} />
							</div>
						</div>
						<div className={styles.blank_table_loader__block__end}>
							<Skeleton style={{ maxWidth: '696px', height: '42px' }} />
							<Skeleton style={{ maxWidth: '696px', height: '42px' }} />
							<Skeleton style={{ maxWidth: '696px', height: '42px' }} />
						</div>
					</div>
					<div className={styles.blank_table_loader__block}>
						<div className={styles.blank_table_loader__block__start}>
							<Skeleton style={{ maxWidth: '17px', height: '17px' }} />
							<div>
								<Skeleton style={{ maxWidth: '167px', height: '42px' }} />
								<Skeleton style={{ maxWidth: '44px', height: '44px' }} />
								<Skeleton style={{ maxWidth: '44px', height: '44px' }} />
								<Skeleton style={{ maxWidth: '44px', height: '44px' }} />
								<Skeleton style={{ maxWidth: '44px', height: '44px' }} />
							</div>
						</div>
						<div className={styles.blank_table_loader__block__end}>
							<Skeleton style={{ maxWidth: '696px', height: '42px' }} />
							<Skeleton style={{ maxWidth: '696px', height: '42px' }} />
							<Skeleton style={{ maxWidth: '696px', height: '42px' }} />
						</div>
					</div>
				</div>
			) : (
				<div className={styles.blank_table_loader}>
					{[...Array(n)].map((el, index) => (
						<div className={styles.blank_table_loader__main} key={index}>
							<Skeleton style={{ maxWidth: '290px', height: '20px' }} />
							<Skeleton style={{ maxWidth: '490px', height: '20px' }} />
							<Skeleton style={{ maxWidth: '122px', height: '20px' }} />
							<Skeleton style={{ maxWidth: '122px', height: '20px' }} />
						</div>
					))}
					<div className={styles.blank_table_loader__footer}>
						<Skeleton style={{ maxWidth: '322px', height: '36px' }} />
						<Skeleton style={{ maxWidth: '64px', height: '36px' }} />
					</div>
				</div>
			)}
		</>
	);
};
